<script lang="ts" setup>
    import '../../../css/choice.css';
    import { onMounted, ref, reactive } from 'vue';
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import TextInput from '../../components/TextInput.vue';
    import ActionButtonV2 from '../../components/ActionButtonV2.vue'
    import Checkbox from '../../components/Inputs/Checkbox.vue';
    import { ICol } from "../../lib/ChoiceTableHelpers";
    import { ModalStyles, popAlert } from "../../lib/Notification";
    import { MessageSectionType, DisplayStyle, ButtonDisplaySize, ButtonDisplayStyle } from "../../Enums/UiEnums";
    import { ActionButtonStyle} from '../../lib/Types/Types';
    import { UpdoxReminderHistoryItem } from '../../lib/Api/UpdoxReminderHistory';
    import * as ChoiceApi from '../../lib/ChoiceApi';

    //import {open_fax, export_ccd, pdf_print} from "../../../types/LegacyOfficeMDFunctions"

    const tableHeight = ref<number>();

    const formData = reactive<{
        startTime: string, 
        endTime: string, 
        tableData: UpdoxReminderHistoryItem[],
        showFilters: boolean
    }>({
        startTime: "", 
        endTime: "", 
        tableData: [],
        showFilters: false
    });

    const searchColumns = ref<ICol[]>([
        { Name: 'AppointmentId', DataField: 'appointmentId' },
        { Name: 'PatientId', DataField: 'patientId' },
        { Name: 'ReminderId', DataField: 'updoxReminderId' },
        { Name: 'HistoryId', DataField: 'updoxReminderHistoryId' },
        { Name: 'Type', DataField: 'type' },
        { Name: 'Created', DataField: 'createdAt' },
        { Name: 'Sent', DataField: 'sentAt' },
        { Name: 'Replied', DataField: 'repliedAt' },
        { Name: 'Status', DataField: 'reminderStatus' },
        { Name: 'Reason', DataField: 'reminderStatusReason' },
        { Name: 'FilteredAppId', DataField: 'filteringAppointmentId' },
        { Name: 'FilteredAppStatus', DataField: 'filteringAppointmentStatus' },
        { Name: 'FilteredAppointments', DataField: 'filteredAppointmentIds' }
    ]);

    onMounted(async () => {
        windowResize();
    });


    function windowResize() {
        tableHeight.value = window.innerHeight - 80;
    }

    async function onSearch() {
        if (!formData.startTime) {
            await popAlert("Please enter a search start date/time.", "Search", ModalStyles.info);
            return;
        }
        if (!formData.endTime) {
            await popAlert("Please enter a search stop date/time.", "Search", ModalStyles.info);
            return;
        }

        const postData = {
            startTime: formData.startTime,
            endTime: formData.endTime
        };  
        const result = await ChoiceApi.updoxReminderHistory.search(postData);
        if (!result) {
            await popAlert("An error occurred while searching for the reminder history.", "Error", ModalStyles.danger);
            return;
        }
        if (!result.successful) {
            await popAlert(result.responseMessage, "Error", ModalStyles.danger);
            return;
        }
        formData.tableData = result.lines;
}

</script>

<style scoped>
    .fixedInputLabel {
        width: 45px;
    }
    .fixedInputWidth {
        width: 200px;
    }
</style>

<template>
    <ResizeMonitor @resize="windowResize" />
    <div class="row mt-2">
        <div class="fixedInputLabel label-isalus-small mt-2">
            Start
        </div>        
        <div class="fixedInputWidth ps-0">
            <TextInput 
                v-model:textValue="formData.startTime" 
                :cssFramework="'vanilla'"  
                placeholder="mm/dd/yyyy hh:mm:ss"
                :maxLength="20">
            </TextInput>            
        </div>
        <div class="fixedInputLabel label-isalus-small mt-2">
            Stop
        </div>        
        <div class="fixedInputWidth ps-0">
            <TextInput 
                v-model:textValue="formData.endTime" 
                :cssFramework="'vanilla'"  
                placeholder="mm/dd/yyyy hh:mm:ss"
                :maxLength="20">
            </TextInput>            
        </div>
        <div class="col-auto ps-0">
            <ActionButtonV2 
                :action="ActionButtonStyle.Search"
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                text="Search"
                :size="ButtonDisplaySize.Small" 
                tooltip="Search for patient using the search criteria."
                :performAction="onSearch" /> 
        </div>
        <div class="col mt-2 label-isalus-small">
            <Checkbox v-model="formData.showFilters" :title="'Show/Hide Filters on grid'"/>  
            <span label class="ps-1 pe-3">Show Filters</span>               
        </div>
    </div>
    <div class="row mt-2">
        <div class="col">
            <ChoiceTable 
                ref="printTable"
                :columns="searchColumns" 
                :data="formData.tableData" 
                :show-filters="formData.showFilters" 
                :allowSorting="true"
                :height="tableHeight"
                fontSize="smaller"
                :key-value-data-member="'appointmentId'">
                <template #cell="{col, row, value}">
                    <template v-if="'Comment' === col.Name">
                        {{ value.join(", ") }}
                    </template>
                </template>
            </ChoiceTable>
        </div>
    </div>
</template>

